<template>
  <v-app>
    <div class="tw-relative tw-p-[30px]">
      <div class="tw-text-center tw-font-medium tw-text-[20px] tw-text-secondary tw-mb-[30px]">
        Review <span class="tw-text-primary">Order #{{ delivery.id }}</span> – {{ receiverName }}
      </div>
      <v-form class="tw-grid tw-gap-[20px]">
        <div>
          <h5 class="tw-font-medium tw-text-secondary tw-mb-[8px]">Rate</h5>
          <v-rating
            half-icon="fa-star-half-alt"
            size="18"
            color="#FBAB1E"
            background-color="#FBAB1E"
            class="custom--v-rating"
            v-model="review.star"
          />
        </div>
        <div>
          <h5 class="tw-font-medium tw-text-secondary tw-mb-[8px]">Write some comments</h5>
          <v-textarea
            rows="3"
            aria-valuemin="5"
            outlined
            auto-grow
            placeholder="Write some comment"
            :rules="commentRules"
            v-model.trim="review.comment"
          >
          </v-textarea>
        </div>
        <div class="d-flex align-center justify-center">
          <v-btn
            class="!tw-w-full"
            elevation="0"
            color="primary"
            height="50"
            :width="$vuetify.breakpoint.smAndDown ? '100%' : '400' "
            :disabled="$v.review.$invalid"
            @click.prevent="submitReview"
          >
            Submit
          </v-btn>
        </div>
      </v-form>
      <v-btn icon @click="close" class="tw-absolute tw-top-0 tw-right-0">
        <img src="assets/icons/delete.svg" alt="x-icon"/>
      </v-btn>
    </div>
  </v-app>
</template>

<script>
import { validationMixin } from "vuelidate";
import { maxLength, minLength, required } from "vuelidate/lib/validators";
import { mapActions, mapGetters, mapState } from "vuex";
import loading from "@/mixins/loading";

export default {
  mixins: [
    loading,
    validationMixin
  ],

  props: {
    delivery: {
      type: Object,
      required: true,
    },

    isCompanyOrBranch: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      review: {},
      commentRules: [
        v => !!v || 'Comment is required',
        v => (v && v.length >= 10) || 'Comment must be more than 10 characters',
      ],
    }
  },

  computed: {
    ...mapGetters('auth', [ 'user', 'activeBranch', 'isCustomer' ]),
    ...mapState('auth', [ 'company' ]),

    receiverName() {
      return this.isCompanyOrBranch ? this.delivery.customer.name : this.delivery.acceptor.name;
    }
  },

  methods: {
    ...mapActions('review', [ 'set_review_to_helper_delivery', 'set_review_to_customer_delivery' ]),

    submitReview() {
      if (this.isCompanyOrBranch) {
        this.startLoading(async () => {
          await this.set_review_to_customer_delivery({
            delivery_id: this.delivery.id,
            star: this.review.star,
            comment: this.review.comment
          });

          await this.$store.dispatch('dashboard/load');
          this.$emit('close');
        });
      } else {
        this.startLoading(async () => {
          await this.set_review_to_helper_delivery({
            delivery_id: this.delivery.id,
            star: this.review.star,
            comment: this.review.comment
          });
          this.$emit('close');
        });
      }
    },

    close() {
      this.$emit('close');
    }
  },

  validations: {
    review: {
      star: {
        required: required
      },
      comment: {
        required: required,
        minLength: minLength(10),
        maxLength: maxLength(1500)
      }
    }
  },
}
</script>
